<template>
  <div>
    <div v-if="!_isMobile()">
      <div class="foot flex">
        <section>
          <img src="../../assets/images/0_img_logo.png" alt="" />
          <div class="text1">
            <span>EXPLORATION TODAY</span>
            <span style="margin-left: 10px">INNOVATION FOREVER</span>
          </div>
          <div class="text2">
            Pioneering
            <span>|</span>
            Exploring
            <span>|</span>
            Innovating
            <span>|</span>
            Surpassing
          </div>
        </section>
        <section class="flex right-sec">
          <div class="input">
            <div class="title-text">SUBSCRIBE NOW</div>
            <el-input v-model="value" placeholder=""></el-input>
            <el-button>Subscribe</el-button>
          </div>
          <div class="info">
            <div class="title-text">CONTACTS</div>
            <div class="text3">
              <span>Email：</span>service@pharmoptima.com.cn
            </div>
            <div class="text4"><span>Tel：</span>+86-021-58550200</div>
          </div>
        </section>
      </div>
      <div class="page-info">
        SHANGHAI PharmOptima co., Ltd | Privacy Policy© 2024&nbsp;<a style="color: #f9f9f9" href="https://beian.miit.gov.cn" target="_blank" previewlistener="true">沪ICP备2024089134号-1</a>
      </div>
    </div>
    <!-- 移动端页脚 -->
    <div v-if="_isMobile()">
      <div class="mb_footer">
        <div class="footerItem">
          <img src="@/assets/images/0_icon_pho.png" alt="">
          service@pharmoptima.com.cn
        </div>
        <div class="footerItem">
          <img src="@/assets/images/0_icon_ema.png" alt="">
          +86-021-58550200
        </div>

      </div>
      <div class="mb_banquan">
        <div class="item">Copyright©2018-2022 LabMaster.top All Rights Reserved.</div>
        <div class="item">沪ICP备18048163号</div>
      </div>



    </div>
  </div>
</template>
<script>
export default {
  name: "footView",
  data() {
    return {
      value: "",
    };
  },
  methods: {
    // 判断是否是手机端，如果是，返回true
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/app.less";
.mb_footer {
  height: 100px;
  background-color: #1a1c1d;
  color: white;
  padding: 10px 0;
  border-bottom: 1px solid #ccc;
  .footerItem {
    display: flex;
    justify-content: center;
    margin: 10px 0;

    img {
      width: 20px;
      height: 100%;
      margin-right: 8px;
    }
  }
}
.mb_banquan {
  color: #ccc;
  height: 60px;
  background-color: #1c1e1f;
  font-size: 12px;
  padding: 8px 0;
  box-sizing: border-box;
  .item {
    display: flex;
    justify-content: center;
  }

}
</style>
